export const socialsData = {
    github: 'https://github.com/Whatsuf148',
    facebook: 'https://www.facebook.com/sachin.dhakal.148/',
    linkedIn: 'https://www.linkedin.com/in/sachin-dhakal-182a27214/',
    instagram: 'https://www.instagram.com/whatsufdhakal/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/SachinD60192190',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/21656343/sachin-dhakal',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}